<template>
  <div tabindex="20" class="grid-container full">
    <div class="grid-x">
      <div class="small-12 cell text-center">
        <h2>Our Board</h2>
      </div>
    </div>

    <div>
    <div class="grid-x">
      <div class="small-12 cell carousel-cont">

        <div class='carousel-view'>
          <transition-group
            name='carousel'
            class='carousel'
            tag="div">
            <div
              v-for="slide in slides"
              class='slide'
              :key="slide.id">
              <img class='slide-image' :src='slide.imgLink' :alt='slide.altText'>
            </div>
          </transition-group>
        </div>

        <div class="grid-x carousel-controls">
          <div class="small-1 cell align-center align-middle" style="display: flex; " @click="previous">
            <img tabindex="21" class="prevArrow" src="@/assets/img/icons/left.png" @keypress="previous" />
          </div>
          <div class="small-10">&nbsp;</div>
          <div class="small-1 cell align-center align-middle" style="display: flex; " @click="next">
            <img tabindex="22" class="nextArrow" src="@/assets/img/icons/right.png" @keypress="next" />
          </div>
        </div>

      </div>
    </div>
    </div>

    <div>
    <div class="grid-x board-data">
      <div class="small-12 cell page-contents-15">
        <p class="name">{{ name }}</p>
        <p class="position">{{ position }}</p>
        <div v-html="description" class="description"></div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'boardCarousel',
  data() {
    return {
      w: window.width,
      name: null,
      position: null,
      description: null,
      slides: [
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Rasvi.jpg'),
          altText: 'Rasvi is an investment banker specialising in Financial Services M&A, IPOs and strategic advice.',
          name: 'Rasvi Ahmed',
          position: 'Non-Executive Director',
          description: '<p>Rasvi is an investment banker specialising in Financial Services M&A, IPOs and strategic advice. He is currently a Managing Director at BNP Paribas having previously worked for Rothschild and Credit Suisse.</p><p>Rasvi was one of Rare’s very first candidates back in 2006 and has now come full circle having joined the Board as a NED in 2021.</p>',
          id: 9,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Andrew.jpg'),
          altText: 'Andrew Franklin, Non-Executive Director',
          name: 'Andrew Franklin',
          position: 'Non-Executive Director',
          description: '<p>Andrew is the founder and Managing Director of Profile Books, one of Britain\'s leading independent publishers. Profile has been consistently profitable since its second year and has grown continuously. His list of authors includes three Nobel Laureates.</p><p>He is a trustee of the Edinburgh International Book Festival, former Chairman of the Jewish Community Centre for London, and a visiting professor at City University, London.</p>',
          id: 10,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Femi.jpg'),
          altText: 'Femi Fadugba - Non-Executive Director',
          name: 'Femi Fadugba',
          position: 'Non-Executive Director',
          description: '<p>Femi is a former Rare candidate and team member, now serving as CEO of the VR EdTech company ShepherdXR. He is also a Fellow at New College, Oxford, and has just published his second novel with Penguin Random House. Previously, Femi worked as a science tutor, management consultant, and solar salesman. He studied at UPenn and Oxford, where he published research on quantum computing.</p>',
          id: 11,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/SirBell.jpg'),
          altText: 'Sir David Bell, non-executive director',
          name: 'Sir David Bell',
          position: 'Non-Executive Chair',
          description: '<p>Sir David Bell is a non-executive director of the Economist. He is a former Director of Pearson plc, Chairman and CEO of the Financial Times, and Chairman of Pearson Inc.</p><p>David is currently Chairman of Sadler\'s Wells, Chair of Council, Roehampton University, Chairman of the London Transport Museum, Chairman of the Transformation Trust, Chairman of Rare, Chair of Bath Mozartfest, Chair of Cambridge University Press and Chair of The Institute of War & Peace Reporting Europe. He is a trustee of the Esmee Fairbairn Foundation, Pearson Group Pension, Worth School, Cornerstone Property Assets, the Bureau for Investigative Journalism, Girl Hub and the Centre for the Study of Financial Innovation {CSFI,} and a member of the Honorary Council of the Royal National Theatre.</p> <p>David was an Assessor on the Leveson Inquiry into the Culture, Practice and Ethics of the Press and Chairman of the Millennium Bridge Trust.</p>',
          id: 13,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Raph.jpg'),
          altText: 'Raphael Mokades - Rare\'s Managing Director ',
          name: 'Raphael Mokades',
          position: 'Founder and Managing Director',
          description: '<p>Raphael Mokades is the founder and Managing Director of Rare, the multi award-winning recruitment and technology company.</p><p>Raphael founded Rare in 2005, on his own, with no technology expertise, no clients, no systems, and a desk in someone else’s office. Today, Rare works with 150+ elite employers including all five Magic Circle law firms, the top three global strategy consulting firms, two of the world’s top three investment banks, and the universities of Oxford and Cambridge.</p><p>Raphael has a first-class degree from Oxford University. He has written for the Guardian, Times and Financial Times. He has been named in the FT’s Empower Top 100 Ethnic Minority Executives list, and as Legal Week’s Outstanding Innovator.</p>',
          id: 1,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Kura.jpg'),
          altText: 'Kura Dione-Warren, Director, Head of Account Management',
          name: 'Kura Dione-Warren',
          position: 'Director, Strategic Development',
          description: '<p>Kura originally joined Rare as a candidate, becoming a Director in 2013. In that time, she has been instrumental in building our reputation for excellence and has consistently delivered outstanding results for her clients. Kura now oversees our business development. Kura was named in the prestigious 35 Women Under 35 list for Management Today’s Inspiring Women in Business Awards 2021, citing her impressive results leading the team responsible for Rare\'s sales, retention services, lateral hiring and communications.</p><p>At Rare, Kura has completed secondments at The Economist Group and JWT in New York, Thomson Reuters in Singapore and Ubuntu Education Fund in South Africa, where she set up an employment programme. She continues to support Ubuntu as a consultant on their job skills programme.</p>',
          id: 2,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Chetan.jpg'),
          altText: 'Chetan Halai - Director, product management',
          name: 'Chetan Halai',
          position: 'Director, product management',
          description: '<p>Chetan worked on candidate management, account management, then business development before moving into product development for Rare. His first role was on L’Oréal’s Marketing Graduate scheme as a Rare candidate, where he cut his teeth in digital marketing for global brands including Urban Decay, Viktor & Rolf and Diesel Fragrances.</p><p>Chetan is currently responsible for overseeing the development of our award-winning software products, and has been instrumental in bringing the pioneering Candid ATS and Vantage to life. He serves as a Trustee for two charities: Yog Foundation (a community based charity) and Initiatives of Change UK, and nurtures a passion for photography and Indian Classical music.</p>',
          id: 3,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Anna.jpg'),
          altText: 'Anna Burgess - Director, HR and Administration',
          name: 'Anna Burgess',
          position: 'Director, Finance and HR',
          description: '<p>Anna joined Rare from Goldman Sachs in 2009. She initially managed our financial services, technology and public sector clients. Within a year, she had grown this area by 50%. Under her leadership, our clients hired more than one thousand Rare candidates. As Rare has grown, Anna has been instrumental in building our Finance, HR and Administration team, which she now leads. \n' +
            'Anna was a talented junior gymnast and is a huge film buff.</p>',
          id: 4,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Daniel.jpg'),
          altText: 'Daniel Mokades - Rare\'s Director of People Performance',
          name: 'Daniel Mokades',
          position: 'Director of software & client services',
          description: '<p>Daniel oversees our software development and recruitment services. He has a deep background in coaching, assessment, and development. He is a qualified Executive Coach, and has designed, overseen and advised on assessment and selection processes for a wide range of corporations, banks, law firms, charities and public sector organisations.</p><p>During almost fifteen years of working at Rare, Daniel has been instrumental in cementing our reputation for providing world class coaching and helping Rare to grow to its current size.</p><p>He is the author of several books, including <i>The Path to Coaching Mastery</i>. He is also a highly accomplished origamiist.</p>',
          id: 5,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Sandra.jpg'),
          altText: 'Sandra Scheerer, Director in Pillsbury\'s Global Technology and Sourcing Practice Group in London',
          name: 'Sandra Scheerer',
          position: 'Non-Executive Director',
          description: '<p>Sandra is a consultant to City law firms and a former Director in Pillsbury\'s Global Technology and Sourcing Practice Group in London. Sandra was previously General Counsel and Board member at Unisys Limited, where she negotiated and advised on all outsourcing projects, some of which were the biggest in the UK. She was the youngest person on the Unisys board, and the first woman ever to be appointed to it. Sandra also advises various charities, is a former Board member of Sense and is on the board of the Microloan Foundation.</p>',
          id: 6,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/DonovanFrew.jpg'),
          altText: 'Donovan Frew, Non-Executive Director',
          name: 'Donovan Frew',
          position: 'Non-Executive Director',
          description: '<p>Donovan studied Computer Science, Economics and Marketing at the University of West Indies and Software Engineering at the University of York.</p><p>He has been a technology professional for almost twenty years and is currently the Chief Technology Officer at Goodlord. He was previously CTO at Stratajet and Secret Escapes where he led the expansion into Europe, the USA and Asia covering thirteen territories, eight languages and five new currencies.</p>',
          id: 7,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/photos/board/Sarah.jpg'),
          altText: 'Sarah Lee - Non-Executive Director',
          name: 'Sarah Lee',
          position: 'Non-Executive Director',
          description: '<p>Sarah Lee is a lawyer and former partner and board member at Slaughter and May. She is currently a Non-Executive Director of the Financial Ombudsman Service, a Commissioner of the Judicial Appointments Commission, a Non-Executive Director of the Independent Press Standards Organisation and the Chair of Islington Giving.</p><p>Sarah has spent most of her legal career as a partner of Slaughter and May. During her time at the firm, Sarah was Head of the Dispute Resolution Group.</p>',
          id: 8,
        },
      ],
    };
  },

  methods: {
    next() {
      this.name = this.slides[5].name;
      this.position = this.slides[5].position;
      this.description = this.slides[5].description;
      const first = this.slides.shift();
      this.slides = this.slides.concat(first);
    },
    previous() {
      this.name = this.slides[3].name;
      this.position = this.slides[3].position;
      this.description = this.slides[3].description;
      const last = this.slides.pop();
      this.slides = [last].concat(this.slides);
    },
  },
  mounted() {
    this.name = this.slides[4].name;
    this.position = this.slides[4].position;
    this.description = this.slides[4].description;
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .carousel-cont {
    position: relative;
  }

  .carousel-view {
    position: absolute;
    height: 377px;
    display: flex;
    flex-direction: column ;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-bottom: 30px;
    width: 100%;
  }

  .carousel {
    display: flex;
    justify-content: center;
    align-items: center;
    -ms-flex-pack: center;
    width: 100%;
    // Increase left padding by approx 712px if you add another slide.
    padding-left: 2080px;
    min-height: 377px;
    overflow: hidden;
    position: relative;
  }

  h2 {
     font-weight: bold;
     font-style: normal;
     font-stretch: normal;
     text-align: center;
   }

  p.name {
    color: $green-highlight;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    text-transform: uppercase;
  }

  p.position {
    color: #4d5b67;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 1024px)  {
    .carousel {
      margin-left: -220px;
    }
  }


  @media only screen and (max-width: 640px)  {

    .carousel-controls {
      position: relative;
      top: 120px;
    }

    .carousel-view {
      height: 200px;
    }
    .carousel {
      min-height: 200px;
      padding-left: 860px;
    }

    .slide {
      transform: translateZ(0) scale(1.0, 1.0);
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      transition: transform 0.3s ease-in-out;
      opacity: 0.5;
      flex: 0 0 15em;
      overflow: hidden;
    }

    .slide img {
      height: 128px;
      transition: height 1s;
    }

    .slide:first-of-type, .slide:last-of-type {
      opacity: 0 !important;
    }

    .slide:nth-of-type(5n) {
      opacity: 1 !important;
      transition: opacity 1s;
    }

    .slide:nth-of-type(5n) img {
      height: 176px;
    }

    .board-data {
      margin-top: 200px;
    }

    h2 {
      display: block;
      font-size: 28px;
      line-height: 1.43;
      margin: 43px auto 13px auto;
    }

    p.name {
      font-size: 21px;
      line-height: 1.51;
    }

    p.position {
      font-size: 14px;
      line-height: 1.71;
      font-weight: 300;
      margin-bottom: 20px;
      margin-top: -15px;
    }

    .prevArrow {
      cursor: pointer;
      display: inline-flex;
      height: 32px;
    }

    .nextArrow {
      cursor: pointer;
      display: inline-flex;
      height: 32px;
    }

  }

  @media only screen and (min-width: 641px) and (max-width: 1155px) {
    .carousel {
      margin-left: -750px;
    }

    .slide {
      flex: 0 0 30em !important;
    }
  }

  @media only screen and (min-width: 641px) {

    .carousel-controls {
      position: relative;
      top: 120px;
    }

    .slide {
      transform: translateZ(0) scale(1.0, 1.0);
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      transition: transform 0.3s ease-in-out;
      opacity: 0.5;
      // Adjust the last value in the line below if you add or delete board memebers.
      // (Decrease if you add, increase if you delete).
      flex: 0 0 49em;
      overflow: hidden;
    }

    .slide img {
      height: 274px;
      transition: height 1s;
    }

    .slide:nth-of-type(5n) {
      opacity: 1 !important;
    }

    .slide:nth-of-type(5n) img {
      height: 377px;
    }


    .board-data {
     margin-top: 360px;
    }

    h2 {
      font-size: 56px;
      line-height: 1.29;
      margin: 96px auto 32px auto;
    }

    p.name {
      font-size: 36px;
      line-height: 1.11;
      letter-spacing: 3px;
      margin-top: 17px;
    }

    p.position {
      font-size: 24px;
      line-height: 1.67;
      letter-spacing: 3px;
      margin-top: -10px;
    }

     p {
      font-size: 21px !important;
      line-height: 1.52;
    }

    .prevArrow {
      cursor: pointer;
      display: inline-flex;
      height: 48px;
    }

    .nextArrow {
      cursor: pointer;
      display: inline-flex;
      height: 48px;
    }


  }

  // Targets ONLY IE11.
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {

    .carousel-view {
      margin-left: 180px;
    }

    .carousel {
      width: 100% !important;
      text-align: center;
    }
    .slide {
      transition: none !important;
      display: none !important;
      overflow: visible;
      width: 100%;
      transition: none;
      margin: 0 27% 0 0;
    }

    .slide:nth-of-type(5) {
      display: block !important;
      text-align: center;
    }

    .slide:nth-of-type(5) img {
      //margin-right: 50px;
    }
  }

  // Targets ONLY Edge browsers.
  @supports (-ms-ime-align:auto) {

    .carousel-view {
      position: relative;
    }

    .carousel-controls {
      position: relative !important;
      top: 0 !important;
      margin: 0 !important;
    }

    .board-data {
      margin-top: 0;
    }

    .carousel-view {
      margin-bottom: 0;
    }
  }


</style>

<style>

  .description p {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }


  @media only screen and (max-width: 640px)  {

    .description p {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.56;
    }

    .description p:last-of-type {
      margin-bottom: 42px;
    }

  }

  @media only screen and (min-width: 641px) {

    .description p {
      font-size: 21px !important;
      line-height: 1.52;
    }

    .description p:last-of-type {
      margin-bottom: 96px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/carousels/boardCarousel.vue